Backbone.Radio.channel('views').reply('form-matchinggifts',function(options){
	var opts = {
		
	}
	
	var radio = Backbone.Radio.channel('pledgeform')
	
	var view = Marionette.View.extend({
		 template:_.template($("#tmpl-form-matchinggifts").html())
		,events:{
			'click #searchForMatchingGift':function(){
				if($('#employer').val().length)
					this.searchForEmployer($('#employer').val());
					
				return false;
			}
			,'click #employerResults button':function(e){
				e.preventDefault();
				
				var $e = $(e.currentTarget),
					id = $e.data('id'),
					htm ='';
					
				if(id && id != -1 ){
					//set name and id
					$('#employer').val( $e.data('name') ).data('id', id)
					htm = "<p class='alert'>Great! Your company does take part in a matching gift program.  Your confirmation email will contain more details.</p>";
				}else{
					//"None of These" button clicked, so clear any past IDs
					$('#employer').data('id', '')
				}
				//regardless of button clicked, remove the results
				$('#employerResults').empty().append(htm).slideDown()
			}

		}
		,onAttach:function(){
			/* pTooltip has its own lib file */
			this.$el.find('#employerReadMore').pTooltip();
		}
		,searchForEmployer:function(searchString){
			var that = this;
			var search = $.ajax({
				'url':'/api/matchinggift.ajax.php',
				'dataType':'json',
				'data':{
					'f':'name_searches',
					'val':searchString
				}
			});
			
			search.done(function(data){
				that.showEmployers(data)
			});
		}
		,showEmployers:function(r){
			var htm = '';
			if(r && r.company && r.company.length){
				for(var i=0,l=r.company.length;i<l;i++){
					htm += "<div class='row'>";
					htm += "<div class='col-8 mb2 result'>";
						htm += "<div class='row'>";
						htm += "<div class='col-9'>";
							htm += "<div class='hd'>";
								htm += r.company[i].name;
							htm += "</div>";
							htm += "<div class='bd'>";
								htm += r.company[i].city +", "+r.company[i].state;
							htm += "</div>";
						htm += "</div>";
						htm += "<div class='col-3'>";
							htm += "<button class='btn btn-success' data-id='"+r.company[i].company_id+"' data-name='"+r.company[i].name+"'>Select</button>";
						htm += "</div>";
						htm += "</div>";
					htm += "</div>";
					htm += "</div>";
				}
				//the 'none of those' button
				htm += "<div class='row'><div class='col-8'><div class='hd'><button class='btn btn-danger' data-id='-1'>None of these.</button></div></div></div>";
				
				//wrap it all with some instructions
				htm = '<label class="font-bold">Select Your Employer</label>' + ""+ htm +"";
			}else{
				htm = "<p class='alert'>I'm sorry, your company does not participate in a matching gift program.</p>";
			}
			
			$('#employerResults').empty().append(htm).slideDown();
		}


	})
	
	
	return new (view)();
});